<template>
  <div class="product-add">

    <el-form size="small" ref="formData" :model="formData" label-width="200px">
      <!-- <el-form-item label="免费查看次数" prop="read_num">
        <el-input v-model="formData.read_num" type="text" style="width: 300px;"></el-input>
        <p class="gray">普通用户的免费查看次数</p>
      </el-form-item> -->
      <el-form-item label="允许使用本商城的等级" prop="is_open_recharge">
        <el-select v-model="formData.allow_user_grade_ids" multiple style="width: 400px;" placeholder="请选择">
          <el-option
            v-for="item in grade_list"
            :key="item.grade_id"
            :label="item.name"
            :value="item.grade_id">
          </el-option>
        </el-select>
        <div class="gray9"> 说明：达到了相应的等级的用户才可以正常使用本商城,没有达到等级只能看到错误页面 </div>
      </el-form-item>
      <el-form-item label="禁止使用提示" prop="not_allow_tips">
        <el-input v-model="formData.not_allow_tips" placeholder="禁止使用提示" class="max-w460"></el-input>
        <div class="gray9"> 说明：没有达到等级看到错误页面的提示信息 </div>
      </el-form-item>
      <!-- <el-form-item label="是否开启充值" prop="is_open_recharge">
        <el-switch v-model="formData.is_open_recharge"></el-switch>
      </el-form-item> -->
      <el-form-item label="是否开启禁止注册" prop="is_open_registration">
        <el-switch v-model="formData.is_open_registration"></el-switch>
      </el-form-item>
      <el-form-item label="是否开启获取手机号" prop="is_open_getphone">
        <el-switch v-model="formData.is_open_getphone"></el-switch>
      </el-form-item>
      <!-- <el-form-item label="是否开启绑定上级" prop="is_open_bindReferee">
        <el-switch v-model="formData.is_open_bindReferee"></el-switch>
        <p class="gray">开启绑定上级则购买商品时,进入会员中心时均需求绑定上级</p>
      </el-form-item> -->

      <!-- <el-form-item label="申请门店数量" prop="apply_store_num">
        <el-input v-model="formData.apply_store_num" type="number" style="width: 300px;"></el-input>
      </el-form-item> -->

      <el-form-item label="会员切换秘钥" prop="change_secret">
        <el-input v-model="formData.change_secret" type="text" style="width: 300px;"></el-input>
        <p class="gray">可用于移动端切换到用户</p>
      </el-form-item>
      <el-form-item label="会员封禁提示" :rules="[{message: ' '}]" prop="msg">
        <el-input v-model="formData.msg" placeholder="提示" class="max-w460"></el-input>
      </el-form-item>

        <div class="common-form">分账设置</div>
          <el-form-item label="是否开启分账">
          <el-radio-group v-model="formData.is_fz_open">
            <el-radio :label="0">关</el-radio>
            <el-radio :label="1">开</el-radio>
          </el-radio-group>
      </el-form-item>

           <el-form-item label="订单分账比例" prop="msg">
        <el-input v-model="formData.fz_price" placeholder="订单分账比例/%" class="max-w460"></el-input>%
      </el-form-item>

         <el-form-item label="分账对象（手机号）" prop="msg">
        <el-input v-model="formData.fz_phone" placeholder="分账对象（手机号）" class="max-w460"></el-input>
      </el-form-item>

      <div class="common-form">会员申请设置</div>
      <el-form-item label="升级申请">
        <el-radio-group v-model="formData.auth_setting.is_open">
          <el-radio :label="0">关</el-radio>
          <el-radio :label="1">开</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="实名认证">
        <el-radio-group v-model="formData.auth_setting.need_certification">
          <el-radio :label="0">无</el-radio>
          <el-radio :label="1">实名认证【可不审核】</el-radio>
          <el-radio :label="2">实名认证【必须审核】</el-radio>
        </el-radio-group>
        <p class="gray">开启申请是否需要实名认证</p>
      </el-form-item>
      <el-form-item label="可申请的用户等级">
        <el-select v-model="formData.auth_setting.grade_id" multiple style="width: 400px;" placeholder="请选择">
          <el-option
            v-for="item in grade_list"
            :key="item.grade_id"
            :label="item.name"
            :value="item.grade_id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="申请说明">
        <el-row>
          <el-button icon="el-icon-picture-outline" @click="openUpload()">选择图片</el-button>
          <div v-if="formData.auth_setting.file_path!=''" class="img">
            <img :src="formData.auth_setting.file_path" width="100" height="100" />
          </div>
        </el-row>
        <p class="gray">建议宽度750px，高度不限，建议小于500K</p>
      </el-form-item>
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="primary" @click="onSubmit">提交</el-button>
      </div>
    </el-form>
    <!--上传图片组件-->
    <Upload v-if="isupload" :isupload="isupload" @returnImgs="returnImgsFunc">上传图片</Upload>
  </div>
</template>

<script>
import UserApi from '@/api/user.js';
import Upload from '@/components/file/Upload';
export default {
  components: {
    /*选择商品组件*/
    Upload,
  },
  data() {
    return {
      /*form表单数据*/
      formData: {
        read_num:0,
        // 允许使用本商城的等级用户,如果不写则不开启
        allow_user_grade_ids: '',
        // 禁止使用商城提示
        not_allow_tips: '',
        is_open_getphone: false,
        is_open_bindReferee:false,
        change_secret:'',
        auth_setting:{
          'is_open':0,
          'need_certification':0,
          'grade_id':[],
          'file_path':'',
        },
        msg: '',
        apply_store_num:1,
      },
      grade_list:[],
      isupload: false,
      is_open_recharge: true,
    };
  },
  created() {
    this.getData();
  },

  methods: {

    /*获取数据*/
    getData() {
      let self = this;
      UserApi.settingDetail({}, true)
        .then(data => {
          self.formData = data.data.values;
          if (self.formData.is_open_getphone == true) {
            self.formData.is_open_getphone = true;
          }
          if(self.formData.is_open_recharge == 'true'){
            self.formData.is_open_recharge = true;
          }
          self.grade_list = data.data.grade_list;
        })
        .catch(error => {});
    },
    // 上传
    openUpload(e) {
      this.isupload = true;
    },
    /*获取图片*/
    returnImgsFunc(e) {
      if (e != null && e.length > 0) {
        this.formData.auth_setting.file_path = e[0].file_path;

      }
      this.isupload = false;
    },

    /*提交表单*/
    onSubmit() {
      let self = this;
      let params = this.formData;
      UserApi.editSetting(params, true)
        .then(data => {
          self.$message({
            message: '恭喜你，设置成功',
            type: 'success'
          });
          this.getData();
        })
        .catch(error => {});
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/user/setting/part/Setting.vue